import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject } from 'vue'
import { injectKeyRadioGroupValue, type RadioGroupValue } from '@/types/injectKey'

import Button from './Button.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioButton',
  props: {
    value: {},
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const { value: _value, updateValue } = inject(injectKeyRadioGroupValue) as RadioGroupValue



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Button, {
    checked: !_ctx.disabled && _unref(_value) === _ctx.value,
    disabled: _ctx.disabled,
    type: "radio",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (!_ctx.disabled && _unref(updateValue)(_ctx.value)))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["checked", "disabled"]))
}
}

})